// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const WidgetOrders: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#231f20",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 16 17" width={width} height={height}>
            <path
                fill="currentColor"
                d="M9.429.375H3.77c-.903 0-1.721.532-2.089 1.357L.196 5.075A2.3 2.3 0 0 0 0 6.004v8.085a2.29 2.29 0 0 0 2.286 2.286h11.428A2.29 2.29 0 0 0 16 14.089V6.004c0-.322-.068-.636-.196-.929l-1.486-3.343a2.29 2.29 0 0 0-2.09-1.357zm.857 4.571-.643-3.428h2.586c.45 0 .86.264 1.042.678l1.222 2.75zm-1.165 0H6.88l.642-3.428h.961l.643 3.428zm.022 1.143v2.286H6.857V6.089zm-3.429 0v2.286c0 .632.511 1.143 1.143 1.143h2.286c.632 0 1.143-.51 1.143-1.143V6.089h4.571v8c0 .632-.51 1.143-1.143 1.143H2.286c-.632 0-1.143-.51-1.143-1.143v-8zm0-1.143H1.503l1.222-2.75a1.14 1.14 0 0 1 1.043-.678h2.59z"
            />
        </svg>
    );
};

export default React.memo(WidgetOrders);
